import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'dateHour',
    standalone: true
})
export class DateHourPipe implements PipeTransform {

  transform(value: string): string {
    if (value == '') {
      return '';
    } else {
      const dateHour = value.split("T");
      const [year, month, day] = dateHour[0].split("-");
      const hour = dateHour[1].slice(0, 5);
  
      return `${day}/${month}/${year} - ${hour}`;
    }
  }

}
